// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lgdMGBbDEO42gFIqBN6t {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.MCkpl3ekAIshhQGX4pse {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 16px;
    border: 1px solid;
    border-radius: 5px;
    text-align: center;
}

.eQ_gbx21x_RulW5YU51l {
    flex-shrink: 0;
}

/* Lets a long email address break so it stays inside the box on phones. */
.OGbJUn2JL1nXGjHB4lAr {
    min-width: 0;
    overflow-wrap: anywhere;
}

.M0lAHEoNbrsyMsb1lyOm {
    margin: 8px 0 0;
    padding-left: 20px;
}

.ijegzLc7BRpsxUpj0zhg {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border: 1px solid var(--mui-palette-divider, #e0e0e0);
    border-radius: 4px;
}

.vtkjcwXm8ecOl2PiXkqF {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.u64tvluytfXBM8lDs93A {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.OmLz2S_fTW7LAhE2FYAn {
    flex-shrink: 0;
}

.Ep9qqHhkheiYzqNoh5Je {
    opacity: 0.7;
}

.Q_WGHU02kf2kw5IfKyil {
    display: flex;
    justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/EmailPreferences/EmailPreferencesForm/EmailPreferencesForm.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA,0EAA0E;AAC1E;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B","sourcesContent":[".form {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.warning {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 16px;\n    border: 1px solid;\n    border-radius: 5px;\n    text-align: center;\n}\n\n.warningIcon {\n    flex-shrink: 0;\n}\n\n/* Lets a long email address break so it stays inside the box on phones. */\n.warningText {\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n\n.affectedList {\n    margin: 8px 0 0;\n    padding-left: 20px;\n}\n\n.toggles {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 16px;\n    border: 1px solid var(--mui-palette-divider, #e0e0e0);\n    border-radius: 4px;\n}\n\n.toggleRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n}\n\n.toggleText {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.toggleSwitch {\n    flex-shrink: 0;\n}\n\n.description {\n    opacity: 0.7;\n}\n\n.actions {\n    display: flex;\n    justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `lgdMGBbDEO42gFIqBN6t`,
	"warning": `MCkpl3ekAIshhQGX4pse`,
	"warningIcon": `eQ_gbx21x_RulW5YU51l`,
	"warningText": `OGbJUn2JL1nXGjHB4lAr`,
	"affectedList": `M0lAHEoNbrsyMsb1lyOm`,
	"toggles": `ijegzLc7BRpsxUpj0zhg`,
	"toggleRow": `vtkjcwXm8ecOl2PiXkqF`,
	"toggleText": `u64tvluytfXBM8lDs93A`,
	"toggleSwitch": `OmLz2S_fTW7LAhE2FYAn`,
	"description": `Ep9qqHhkheiYzqNoh5Je`,
	"actions": `Q_WGHU02kf2kw5IfKyil`
};
export default ___CSS_LOADER_EXPORT___;
